<template>
  <div>
    <div v-if="hasBranchIntro" class="product-info-sheet__contain">
      <div v-if="googleAiSummaries.length">
        <h3 class="sheet-title">{{ $t('all_branch_info') }}</h3>
        <google-ai-summary class="wd-mb-1.5" :summaries="googleAiSummaries" :highlights="googleAiHighlights" />
      </div>

      <h3 class="sheet-title">{{ $t('branch_info') }}</h3>

      <div class="sheet-content">
        <div class="intro-info" :class="{ expaned: introExpanStatus }">
          <p ref="introInfo" class="ma-0 wd-whitespace-pre-wrap">{{ product.intro }}</p>
        </div>

        <div v-if="!introExpanStatus && showMoreInfoBtn" class="text-center mt-4 mb-2">
          <v-btn class="action__btn" color="orange50" height="32" variant="text" @click="introExpanStatus = true">
            {{ $t('branch_info_more') }}
          </v-btn>
        </div>
      </div>
    </div>

    <div v-if="facilitiesNumber > 0" class="sub-content__block">
      <v-divider v-if="hasBranchIntro" class="sheet__divider" />

      <h3 class="sheet-title">{{ $t('all_facility') }}</h3>

      <div class="sheet-content wd-mb-3 wd-flex wd-flex-wrap">
        <div v-for="(n, idx) in facilitiesNumber" :key="idx" class="feature-icon wd-my-2 wd-flex wd-items-center">
          <v-img class="wd-w-32" :src="facilityImageURL(product.facilities[idx].icon)" :alt="product.facilities[idx].name" max-width="32" cover />

          <span v-if="!isMobile" class="feature-text wd-ml-5"> {{ product.facilities[idx].name }} </span>
        </div>

        <v-btn
          v-if="product.facilities.length > maxIconNumber"
          class="action__btn my-2 py-2 px-4"
          color="orange50"
          min-width="32"
          height="48"
          variant="text"
          @click="openFacilitiesModal"
        >
          <v-icon size="32"> mdi-dots-horizontal </v-icon>
          <span v-if="!isMobile" class="ml-5"> {{ $t('show_all') }} </span>
        </v-btn>
      </div>
    </div>

    <branch-facilities-modal ref="facilitiesModal" :items="product.facilities" :is-mobile="isMobile" />
  </div>
</template>
<script>
import BranchFacilitiesModal from '@/components/dialog/branch-facilities'
import GoogleAiSummary from '@/components/ai-summary/google-ai-summary.vue'

import utils from '@/utils'

export default {
  name: 'BranchIntroSheet',
  components: {
    BranchFacilitiesModal,
    GoogleAiSummary,
  },
  props: {
    product: { type: Object, default: () => ({}) },
    isMobile: { type: Boolean, default: false },
    googleAiSummaries: { type: Array, default: () => [] },
    googleAiHighlights: { type: Array, default: () => [] },
  },
  data() {
    return {
      showMoreInfoBtn: false,
      introExpanStatus: false,
    }
  },
  computed: {
    hasBranchIntro() {
      return !!this.product?.intro
    },
    maxIconNumber() {
      return this.isMobile ? 5 : 8
    },
    facilitiesNumber() {
      const facilities = this.product.facilities || []
      return facilities.length > 0 ? (facilities.length > this.maxIconNumber ? this.maxIconNumber : facilities.length) : 0
    },
  },
  mounted() {
    this.showingMoreInfoBtn()
  },
  methods: {
    facilityImageURL(icon) {
      return `${utils.CDN}${icon}`
    },
    showingMoreInfoBtn() {
      if (this.$refs.introInfo && this.$refs.introInfo.getBoundingClientRect) {
        this.showMoreInfoBtn = this.$refs.introInfo.getBoundingClientRect().height > 100
      }
    },
    openFacilitiesModal() {
      this.$refs.facilitiesModal.showModal()
    },
  },
}
</script>
<style lang="scss" scoped>
.product-info-sheet__contain {
  .intro-info {
    max-height: 100px;
    overflow: hidden;

    .intro-list:not(:last-child) {
      margin-bottom: 12px;
    }

    &.expaned {
      max-height: unset;
    }
  }
}

.sub-content__block {
  margin-top: 20px;

  @include xxs {
    margin-top: 12px;
  }

  .feature-icon {
    width: 32%;
    max-width: 223px;
    padding: 8px 20px;

    .feature-text {
      width: calc(100% - 32px);
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    @include xxs {
      width: auto;
      padding: 8px 28px 8px 0;
    }
  }

  .action__btn {
    @include xxs {
      width: 32px;
    }
  }
}
</style>
